<template>
<div class="content">
    <div class="container-fluid" v-if="loading">
        <div class="row">
            <div class="col-xl-12">
                <h2>Loading...</h2>
            </div>
        </div>
    </div>
    <div class="container-fluid" v-if="!loading">
        <div class="row">
            <div class="col-xl-6 col-md-6">
                <stats-card>
                    <div slot="header" class="icon-warning">
                        <i class="nc-icon nc-chart text-warning"></i>
                    </div>
                    <div slot="content">
                        <p class="card-category">AWS Costs (Last Month)</p>
                        <h4 data-cy='aws_last_spender' class="card-title">{{aws_last_spender}}</h4>
                    </div>
                    <div slot="footer">
                        <i class="fa fa-refresh"></i>Updated daily / page refreshed at {{last_update}}
                    </div>
                </stats-card>
            </div>
            <div class="col-xl-6 col-md-6">
                <stats-card>
                    <div slot="header" class="icon-warning">
                        <i class="nc-icon nc-chart text-warning"></i>
                    </div>
                    <div slot="content">
                        <p class="card-category">AWS Costs (Current Month)</p>
                        <h4 data-cy='aws_cur_spender' class="card-title">{{aws_cur_spender}}</h4>
                    </div>
                    <div slot="footer">
                        <i class="fa fa-refresh"></i>Updated daily / page refreshed at {{last_update}}
                    </div>
                </stats-card>
            </div>

        </div>
        <div class="row">
            <div class="col-12 col-xl-6 col-md-12 col-lg-12 rotated-labels">
                <chart-card  data-cy='aws_budget' :key='aws_budget_data' :chart-data="aws_budget_data.data" :chart-options="aws_budget_data.options" :responsive-options="aws_budget_data.responsiveOptions">
                    <template slot="header">
                        <h4 class="card-title">AWS Budget Run</h4>
                        <p class="card-category">Accumulative $M per month - (LetGo exc.)</p>
                    </template>
                    <template slot="footer">
                        <div class="legend">
                            <i class="fa fa-circle text-info"></i> Invoiced (no VAT)
                            <i class="fa fa-circle text-danger"></i> Budget
                            <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
                        </div>
                        <hr>
                        <div class="stats">
                            <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
                        </div>
                    </template>
                </chart-card>
            </div>

            <div class="col-12 col-xl-6 col-md-12 col-lg-12 rotated-labels">
                <chart-card  data-cy='aws_commitment' :key='aws_commit_data' :chart-data="aws_commit_data.data" :chart-options="aws_commit_data.options" :responsive-options="aws_commit_data.responsiveOptions" chart-type="Bar">
                    <template slot="header">
                        <h4 class="card-title">AWS EDP Commitment Run
                        <b-form-select data-cy='contract_selector' v-model="current_contract" :options="contracts_list"></b-form-select>
                        </h4>
                        <p class="card-category">Accumulative $M per month</p>
                        <p class="card-category"><i class="fa fa-circle" :style="{color: status_1st}"/>Commitment Run 1st year {{gaps_1st}}</p>
                        <p class="card-category"><i class="fa fa-circle" :style="{color: status_2nd}"/>Commitment Run 2nd year {{gaps_2nd}}</p>
                    </template>
                    <template slot="footer">
                        <div class="legend">
                            <i class="fa fa-circle text-info"></i> OLX
                            <i class="fa fa-circle text-danger"></i> LetGo
                            <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
                        </div>
                        <hr>
                        <div class="stats">
                            <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
                        </div>
                    </template>
                </chart-card>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-6 col-md-12 col-lg-12 rotated-labels">
                <chart-card  data-cy='aws_coverage_recent' :key='aws_reservation_cov_interest_data' :chart-data="aws_reservation_cov_interest_data.data" :chart-options="aws_reservation_cov_interest_data.options" :responsive-options="aws_reservation_cov_interest_data.responsiveOptions" chart-type="Line">
                    <template slot="header">
                        <h4 class="card-title">AWS Reservation Coverage</h4>
                        <p class="card-category"> New generations and regions of interest only</p>
                        <div>
                            <multiselect v-model="filtered1" label="name" track-by="code" :options="options" :multiple="true" :taggable="true"></multiselect>
                        </div>
                    </template>
                    <template slot="footer">
                        <div class="legend">
                            <div v-for="(lbl,i) in aws_reservation_cov_interest_data.data.services" :key='filtered1'>
                                <i class="fa fa-circle" :style='{color: colors[i]}'></i>{{ serviceFullNames[lbl] }}&nbsp&nbsp&nbsp&nbsp
                            </div>
                            <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
                        </div>
                        <hr>
                        <div class="stats">
                            <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
                        </div>
                    </template>
                </chart-card>
            </div>
            <div class="col-12 col-xl-6 col-md-12 col-lg-12 rotated-labels">
                <chart-card  data-cy='aws_coverage_all' :key='aws_reservation_cov_all_data' :chart-data="aws_reservation_cov_all_data.data" :chart-options="aws_reservation_cov_all_data.options" :responsive-options="aws_reservation_cov_all_data.responsiveOptions" chart-type="Line">
                    <template slot="header">
                        <h4 class="card-title">AWS Reservation Coverage</h4>
                        <p class="card-category"> All generations and all regions</p>
                        <div>
                            <multiselect v-model="filtered2" label="name" track-by="code" :options="options" :multiple="true" :taggable="true"></multiselect>
                        </div>

                    </template>
                    <template slot="footer">
                        <div class="legend">
                            <div v-for="(lbl,i) in aws_reservation_cov_all_data.data.services" :key='filtered2'>
                                <i class="fa fa-circle" :style='{color: colors[i]}'></i> {{ serviceFullNames[lbl] }}&nbsp&nbsp&nbsp&nbsp
                            </div>
                            <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
                        </div>
                        <hr>
                        <div class="stats">
                            <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
                        </div>
                    </template>
                </chart-card>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-6 col-md-12 col-lg-12 rotated-labels">
                <chart-card  data-cy='aws_usage_recent' :key='aws_reservation_uti_interest_data' :chart-data="aws_reservation_uti_interest_data.data" :chart-options="aws_reservation_uti_interest_data.options" :responsive-options="aws_reservation_uti_interest_data.responsiveOptions" chart-type="Line">
                    <template slot="header">
                        <h4 class="card-title">AWS Reservation Utilisation</h4>
                        <p class="card-category"> New generations and regions of interest only</p>
                        <div>
                            <multiselect v-model="filtered3" label="name" track-by="code" :options="options" :multiple="true" :taggable="true"></multiselect>
                        </div>

                    </template>
                    <template slot="footer">
                        <div class="legend">
                            <div v-for="(lbl,i) in aws_reservation_uti_interest_data.data.services" :key='filtered3'>
                                <i class="fa fa-circle" :style='{color: colors[i]}'></i> {{ serviceFullNames[lbl] }}&nbsp&nbsp&nbsp&nbsp
                            </div>
                            <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
                        </div>
                        <hr>
                        <div class="stats">
                            <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
                        </div>
                    </template>
                </chart-card>
            </div>
            <div class="col-12 col-xl-6 col-md-12 col-lg-12 rotated-labels">
                <chart-card  data-cy='aws_usage_all' :key='aws_reservation_uti_all_data' :chart-data="aws_reservation_uti_all_data.data" :chart-options="aws_reservation_uti_all_data.options" :responsive-options="aws_reservation_uti_all_data.responsiveOptions" chart-type="Line">
                    <template slot="header">
                        <h4 class="card-title">AWS Reservation Utilisation</h4>
                        <p class="card-category"> All generations and all regions</p>
                        <div>
                            <multiselect v-model="filtered4" label="name" track-by="code" :options="options" :multiple="true" :taggable="true"></multiselect>
                        </div>

                    </template>
                    <template slot="footer">
                        <div class="legend">
                            <div v-for="(lbl,i) in aws_reservation_uti_all_data.data.services" :key='filtered4'>
                                <i class="fa fa-circle" :style='{color: colors[i]}'></i> {{ serviceFullNames[lbl] }}&nbsp&nbsp&nbsp&nbsp
                            </div>
                            <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
                        </div>
                        <hr>
                        <div class="stats">
                            <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
                        </div>
                    </template>
                </chart-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import axios from 'axios'

import {
    colors,
    formatMoney,
    formatSimple,
    formatSimple2d,
    chart_base,
    g_financial_year,
    g_aws_contract_start,
    // // this.current_contract.aws_budget,
    // // this.current_contract.commitment_1st_olx,
    // this.current_contract.commitment_1st_letgo,
    // this.current_contract.commitment_2nd_olx,
    // this.current_contract.commitment_2nd_letgo,
    g_aws_contract_end,

} from 'src/globalVariables'
import {
    setInterval
} from 'timers';
import Multiselect from 'vue-multiselect'
import chartist from 'chartist'

Number.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

export default {
    components: {
        LTable,
        ChartCard,
        StatsCard,
        Multiselect,
    },
    async created() {
        this.accessToken = await this.$auth.getAccessToken()
        this.filtered1 = this.options
        this.filtered2 = this.options
        this.filtered3 = this.options
        this.filtered4 = this.options
        this.loadData()
        var vm = this
        setInterval(function () {
            vm.loadData()
        }, vm.refresh_minutes * 60 * 1000)

    },
    methods: {
        loadData: function () {
            var today = new Date();
            this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
            console.log('refreshing...', )
            axios
            .get('/aws/contracts?access_token=' + this.accessToken)
            .then(response => (
                this.aws_contracts = response.data                
            ))

            axios
                .get('/aws/top-spenders?access_token=' + this.accessToken)
                .then(response => (
                    this.aws_last_spender = formatMoney.format(response.data.prev),
                    this.aws_cur_spender = formatMoney.format(response.data.cur)
                ))
            axios
                .get('/aws/reservation/statistics?access_token=' + this.accessToken)
                .then(response => (this.aws_reservation_cov_interest = response.data))
            axios
                .get('/aws/reservation/statistics?fullReport=true&access_token=' + this.accessToken)
                .then(response => (this.aws_reservation_cov_all = response.data))
            axios
                .get('/aws/reservation/statistics?statistic=utilisation&access_token=' + this.accessToken)
                .then(response => (this.aws_reservation_uti_interest = response.data))
            axios
                .get('/aws/reservation/statistics?statistic=utilisation&fullReport=true&access_token=' + this.accessToken)
                .then(response => (this.aws_reservation_uti_all = response.data))
            this.loading = false;
            return true
        },
        draw_aws_reservation_cov_interest: function () {
            var labels = []
            var series = []
            var services = []
            var vm = this
            this.services = []
            if (this.aws_reservation_cov_interest) {
                Object.keys(this.aws_reservation_cov_interest).forEach(function (svc, i) {
                    vm.services.push(svc)
                    var dataSerie = []

                    if (
                        vm.filtered1.some(function (it) {
                            if (it['code'] == svc) {
                                return true
                            }
                        })
                    ) {

                        vm.aws_reservation_cov_interest[svc].forEach(function (serie, i) {
                            if (series.length == 0) {
                                labels.push(serie['date'].slice(8, 10) + '-' + serie['date'].slice(5, 7))
                            }
                            dataSerie.push({
                                meta: parseInt(serie['value']) + '%<br/>(' + parseInt(serie['total']) + ' hours)',
                                value: parseInt(serie['value'])
                            })
                        })
                        series.push(dataSerie)
                        services.push(svc)
                    }
                })
            }
            this.labels = labels
            this.aws_reservation_cov_interest_data = {
                'data': {
                    'labels': labels,
                    'series': series,
                    'services': services,   
                },
                'options': Object.assign({}, chart_base.options),
                'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
            }
            //override of chart_base
            this.aws_reservation_cov_interest_data.options.tooltip.tooltipFnc = function (meta, value) {
                var txt = document.createElement('textarea');
                txt.innerHTML = meta;
                return txt.value
            }
            this.aws_reservation_cov_interest_data.options.axisY = {
                    'type': chartist.FixedScaleAxis,
                    'high': 100,
                    'low': 0,
                    'ticks': [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                    'showLabel': true
                },
                this.aws_reservation_cov_interest_data.responsiveOptions = [
                    ['screen and (max-width: 1400)', {
                        'seriesBarDistance': 5,
                        'axisX': {
                            labelInterpolationFnc(value) {
                                return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                            }
                        }
                    }],
                    ['screen and (max-width: 518px)', {
                        'seriesBarDistance': 5,
                        'axisX': {
                            labelInterpolationFnc(value) {
                                return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                            }
                        }
                    }],
                ]
        },
        draw_aws_reservation_cov_all: function () {
            var labels = []
            var series = []
            var services = []
            var vm = this
            this.servicesAll = []
            if (this.aws_reservation_cov_all) {
                Object.keys(this.aws_reservation_cov_all).forEach(function (svc, i) {
                    vm.servicesAll.push(svc)
                    var dataSerie = []
                    if (
                        vm.filtered2.some(function (it) {
                            if (it['code'] == svc) {
                                return true
                            }
                        })
                    ) {

                        vm.aws_reservation_cov_all[svc].forEach(function (serie, i) {
                            if (series.length == 0) {
                                labels.push(serie['date'].slice(8, 10) + '-' + serie['date'].slice(5, 7))
                            }
                            dataSerie.push({
                                meta: parseInt(serie['value']) + '%<br/>(' + parseInt(serie['total']) + ' hours)',
                                value: parseInt(serie['value'])
                            })
                        })
                        series.push(dataSerie)
                        services.push(svc)
                    }
                })
            }
            this.labels = labels
            this.aws_reservation_cov_all_data = {
                'data': {
                    'labels': labels,
                    'series': series,
                    'services': services,   
                },
                'options': Object.assign({}, chart_base.options),
                'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
            }

            //override of chart_base
            this.aws_reservation_cov_all_data.options.tooltip.transformTooltipTextFnc = 0
            this.aws_reservation_cov_all_data.options.tooltip.tooltipFnc = function (meta, value) {
                var txt = document.createElement('textarea');
                txt.innerHTML = meta;
                return txt.value
            }

            this.aws_reservation_cov_all_data.options.axisY = {
                    'type': chartist.FixedScaleAxis,
                    'high': 100,
                    'low': 0,
                    'ticks': [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                    'showLabel': true
                },

                this.aws_reservation_cov_all_data.responsiveOptions = [
                    ['screen and (max-width: 1400)', {
                        'seriesBarDistance': 5,
                        'axisX': {
                            labelInterpolationFnc(value) {
                                return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                            }
                        }
                    }],
                    ['screen and (max-width: 518px)', {
                        'seriesBarDistance': 5,
                        'axisX': {
                            labelInterpolationFnc(value) {
                                return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                            }
                        }
                    }],
                ]
        },
        draw_aws_reservation_uti_interest: function () {
            var labels = []
            var series = []
            var services = []
            var vm = this
            this.servicesUti = []
            if (this.aws_reservation_uti_interest) {
                Object.keys(this.aws_reservation_uti_interest).forEach(function (svc, i) {
                    vm.servicesUti.push(svc)
                    var dataSerie = []
                    if (
                        vm.filtered3.some(function (it) {
                            if (it['code'] == svc) {
                                return true
                            }
                        })
                    ) {

                        vm.aws_reservation_uti_interest[svc].forEach(function (serie, i) {
                            if (series.length == 0) {
                                labels.push(serie['date'].slice(8, 10) + '-' + serie['date'].slice(5, 7))
                            }
                            dataSerie.push({
                                meta: parseInt(serie['value']) + '%<br/>(' + parseInt(serie['TotalActualHours']) + ' hours)',
                                value: parseInt(serie['value'])
                            })
                        })
                        series.push(dataSerie)
                        services.push(svc)
                    }
                })
            }
            this.labels = labels
            this.aws_reservation_uti_interest_data = {
                'data': {
                    'labels': labels,
                    'series': series,
                    'services': services,   
                },
                'options': Object.assign({}, chart_base.options),
                'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
            }

            //override of chart_base
            this.aws_reservation_uti_interest_data.options.tooltip.tooltipFnc = function (meta, value) {
                var txt = document.createElement('textarea');
                txt.innerHTML = meta;
                return txt.value
            }
            this.aws_reservation_uti_interest_data.options.axisY = {
                    'type': chartist.FixedScaleAxis,
                    'high': 100,
                    'low': 0,
                    'ticks': [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                    'showLabel': true
                },
                this.aws_reservation_uti_interest_data.responsiveOptions = [
                    ['screen and (max-width: 1400)', {
                        'seriesBarDistance': 5,
                        'axisX': {
                            labelInterpolationFnc(value) {
                                return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                            }
                        }
                    }],
                    ['screen and (max-width: 518px)', {
                        'seriesBarDistance': 5,
                        'axisX': {
                            labelInterpolationFnc(value) {
                                return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                            }
                        }
                    }],
                ]
        },
        draw_aws_reservation_uti_all: function () {
            var labels = []
            var series = []
            var services = []
            var vm = this
            this.servicesUtiAll = []
            if (this.aws_reservation_uti_all) {
                Object.keys(this.aws_reservation_uti_all).forEach(function (svc, i) {
                    vm.servicesUtiAll.push(svc)
                    var dataSerie = []
                    if (
                        vm.filtered4.some(function (it) {
                            if (it['code'] == svc) {
                                return true
                            }
                        })
                    ) {
                        vm.aws_reservation_uti_all[svc].forEach(function (serie, i) {
                            if (series.length == 0) {
                                labels.push(serie['date'].slice(8, 10) + '-' + serie['date'].slice(5, 7))
                            }
                            dataSerie.push({
                                meta: parseInt(serie['value']) + '%<br/>(' + parseInt(serie['TotalActualHours']) + ' hours)',
                                value: parseInt(serie['value'])
                            })
                        })
                        series.push(dataSerie)
                        services.push(svc)
                    }
                })
            }
            this.labels = labels
            this.aws_reservation_uti_all_data = {
                'data': {
                    'labels': labels,
                    'series': series,
                    'services': services,   
                },
                'options': Object.assign({}, chart_base.options),
                'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
            }
            //override of chart_base
            this.aws_reservation_uti_all_data.options.tooltip.tooltipFnc = function (meta, value) {
                var txt = document.createElement('textarea');
                txt.innerHTML = meta;
                return txt.value
            }
            this.aws_reservation_uti_all_data.options.axisY = {
                    'type': chartist.FixedScaleAxis,
                    'high': 100,
                    'low': 0,
                    'ticks': [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                    'showLabel': true
                },

                this.aws_reservation_uti_all_data.responsiveOptions = [
                    ['screen and (max-width: 1400)', {
                        'seriesBarDistance': 5,
                        'axisX': {
                            labelInterpolationFnc(value) {
                                return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                            }
                        }
                    }],
                    ['screen and (max-width: 518px)', {
                        'seriesBarDistance': 5,
                        'axisX': {
                            labelInterpolationFnc(value) {
                                return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                            }
                        }
                    }],
                ]
        },
    },
    watch: {

        aws_contracts: function(){
            var vm = this
            if (this.current_contract == null){
                this.current_contract = this.aws_contracts[this.aws_contracts.length-1]
            }
            this.aws_contracts.forEach( function(it){
                vm.contracts_list.push(
                    {'value': it, text:it.start_date}
                )
            })
        },
        current_contract: function (){
            var start_financial_year = this.current_contract.start_date.substring(0,4)+'04'
            var end_financial_year = parseInt(this.current_contract.start_date.substring(0,4))+2+'03'
            axios
                .get('/aws/budget-run?st_date='+start_financial_year+'&fn_date='+ end_financial_year +'&access_token=' + this.accessToken)
                .then(response => (this.aws_budget = response.data))

            axios
                .get('/aws/budget-run?st_date='+this.current_contract.start_date.substring(0,6)+'&fn_date='+this.current_contract.end_date.substring(0,6)+'&access_token=' + this.accessToken)
                .then(response => (this.aws_commit = response.data))                
        },
        filtered1: function () {
            this.draw_aws_reservation_cov_interest()
        },
        filtered2: function () {
            this.draw_aws_reservation_cov_all()
        },
        filtered3: function () {
            this.draw_aws_reservation_uti_interest()
        },
        filtered4: function () {
            this.draw_aws_reservation_uti_all()
        },
        aws_reservation_cov_interest: function () {
            this.draw_aws_reservation_cov_interest()
        },
        aws_reservation_cov_all: function () {
            this.draw_aws_reservation_cov_all()
        },
        aws_reservation_uti_interest: function () {
            this.draw_aws_reservation_uti_interest()
        },
        aws_reservation_uti_all: function () {
            this.draw_aws_reservation_uti_all()
        },

        aws_budget: function () {
            var vm = this
            var labels = []
            var series = []
            var budgetline = []
            var aggregate = 0
            var month = 0
            console.log('aws_budget',this.aws_budget)
            if (this.aws_budget) {
                this.aws_budget.forEach(function (v) {
                    if (v['company'] == 'OLX') {
                        month += 1
                        aggregate += v['total_cost'] / 1000000
                        labels.push(v['year_month'].slice(0, 4) + '-' + v['year_month'].slice(4, 6))
                        series.push({
                            meta: aggregate.toFixed(2) + 'M',
                            value: aggregate.toFixed(2)
                        })
                        budgetline.push({
                            meta: (vm.current_contract.aws_budget/24 * (month + 1)).toFixed(2) + 'M',
                            value: (vm.current_contract.aws_budget/24 * (month + 1)).toFixed(2)
                        })
                    }
                })
            }
            this.aws_budget_data = {
                'data': {
                    'labels': labels,
                    'series': [series, budgetline]
                },
                'options': Object.assign({}, chart_base.options),
                'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
            }

            //override of chart_base
            this.aws_budget_data.options.tooltip.transformTooltipTextFnc = function (value) {
                return formatSimple2d.format(value) + 'M'
            }
            this.aws_budget_data.responsiveOptions = [
                ['screen and (max-width: 1400)', {
                    'seriesBarDistance': 5,
                    'axisX': {
                        labelInterpolationFnc(value) {
                            return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                        }
                    }
                }],
                ['screen and (max-width: 518px)', {
                    'seriesBarDistance': 5,
                    'axisX': {
                        labelInterpolationFnc(value) {
                            return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                        }
                    }
                }],
            ]
        },
        aws_commit: function () {
            var labels = []
            var series1 = []
            var series2 = []
            var vm = this
            var commitmentline = []
            var aggregate1 = 0
            var aggregate2 = 0
            var spend_1st_OLX = 0
            var spend_1st_LETGO = 0
            var spend_2nd_OLX = 0
            var spend_2nd_LETGO = 0
            var month = 0
            var olx_cost = 0
            if (this.aws_commit) {
                this.aws_commit.forEach(function (v) {

                    if (v['company'] == 'OLX') {
                        month += 1
                        // reset the second year aggregators
                        if (month == 13) {
                            aggregate1 = 0
                            aggregate2 = 0
                        }
                        olx_cost = v['total_cost'] / 1000000;
                        aggregate1 += v['total_cost'] / 1000000;
                        labels.push(v['year_month'].slice(0, 4) + '-' + v['year_month'].slice(4, 6))
                        if (month <= 12) {
                            spend_1st_OLX = aggregate1
                            series1.push({
                                meta: aggregate1.toFixed(2) + 'M (' + (vm.current_contract.commitment_1st_olx/12 * (month)).toFixed(2) + 'M)',
                                value: aggregate1.toFixed(2)
                            })
                        } else {
                            spend_2nd_OLX = aggregate1
                            series1.push({
                                meta: aggregate1.toFixed(2) + 'M (' + (vm.current_contract.commitment_2nd_olx/12 * (month - 12)).toFixed(2) + 'M)',
                                value: aggregate1.toFixed(2)
                            })
                        }
                    } else { // LETGO 
                        aggregate2 += v['total_cost'] / 1000000;
                        var status = 'rgb(135, 203, 22)'
                        if (month <= 12) {
                            if (aggregate1 + aggregate2 < vm.current_contract.commitment_1st_olx/12 * (month) + vm.current_contract.commitment_1st_letgo/12 * (month))
                                status = 'rgb(255, 0, 0)'
                            spend_1st_LETGO = aggregate2
                            series2.push({
                                meta: aggregate2.toFixed(2) + 'M (' + (vm.current_contract.commitment_1st_letgo/12 * (month)).toFixed(2) + 'M)<br>Total:' + (aggregate1 + aggregate2).toFixed(2) +
                                    'M (' + (vm.current_contract.commitment_1st_olx/12 * (month) + vm.current_contract.commitment_1st_letgo/12 * (month)).toFixed(2) +
                                    'M)<i class="fa fa-circle" style="color:' + status + ';">',
                                value: aggregate2.toFixed(2)
                            })
                        } else {
                            if (aggregate1 + aggregate2 < vm.current_contract.commitment_1st_olx/12 * (month-12) + vm.current_contract.commitment_1st_letgo/12 * (month-12))
                                status = 'rgb(255, 0, 0)'
                            spend_2nd_LETGO = aggregate2
                            series2.push({
                                meta: aggregate2.toFixed(2) + 'M (' + (vm.current_contract.commitment_2nd_letgo/12 * (month - 12)).toFixed(2) + 'M)<br>Total:' + (aggregate1 + aggregate2).toFixed(2) +
                                    'M (' + (vm.current_contract.commitment_2nd_olx/12 * (month - 12) + vm.current_contract.commitment_2nd_letgo/12 * (month - 12)).toFixed(2) +
                                    'M)<i class="fa fa-circle" style="color:' + status + ';">',
                                value: aggregate2.toFixed(2)
                            })

                        }
                    }
                    commitmentline.push({
                        meta: (vm.current_contract.commitment_1st_olx * (month + 1)).toFixed(2),
                        value: (vm.current_contract.commitment_1st_olx * (month + 1)).toFixed(2)
                    })

                })
            }
            this.gaps_1st='' 
            this.gaps_2nd=''

            // first year
            this.status_1st = 'rgb(135, 203, 22)'
            this.status_2nd = 'rgb(135, 203, 22)'
            if (month <= 12){
                console.log('1st',this.current_contract.commitment_1st_olx)
                this.gap_OLX = spend_1st_OLX - this.current_contract.commitment_1st_olx/12  * month 
                this.gap_LETGO = spend_1st_LETGO - this.current_contract.commitment_1st_letgo/12 * month
                console.log(spend_1st_OLX)
            }
            else{
                this.gap_OLX = spend_1st_OLX - this.current_contract.commitment_1st_olx/12 * 12
                this.gap_LETGO = spend_1st_LETGO - this.current_contract.commitment_1st_letgo/12 * 12

            }            

            if (this.gap_OLX + this.gap_LETGO < 0) this.status_1st = 'rgb(255,0,0)'
            this.gaps_1st='- Total: '+(this.gap_OLX + this.gap_LETGO).toFixed(1)+'M'
            this.gaps_1st+=' (OLX: '+(this.gap_OLX).toFixed(1)+'M, '
            this.gaps_1st+=' LetGo: '+(this.gap_LETGO).toFixed(1)+'M) '

            // second year
            if (month > 12){
                month = month - 12
                this.gap_OLX = aggregate1 - this.current_contract.commitment_2nd_olx/12 * month 
                this.gap_LETGO = aggregate2 - this.current_contract.commitment_2nd_letgo/12 * month
                
            if (this.gap_OLX + this.gap_LETGO < 0) this.status_2nd = 'rgb(255,0,0)'
                this.gaps_2nd='- Total: '+(this.gap_OLX + this.gap_LETGO).toFixed(1)+'M'
                this.gaps_2nd+=' (OLX: '+(this.gap_OLX).toFixed(1)+'M, '
                this.gaps_2nd+=' LetGo: '+(this.gap_LETGO).toFixed(1)+'M)'

            }
            this.aws_commit_data = {

                'data': {
                    'labels': labels,
                    'series': [series1, series2]
                },
                'options': Object.assign({}, chart_base.options),
                'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
            }

            //override of chart_base
            this.aws_commit_data.options.tooltip.tooltipFnc = function (meta, value) {
                var txt = document.createElement('textarea');
                txt.innerHTML = meta;
                return txt.value
            }

            // this.aws_commit_data.options.tooltip.transformTooltipTextFnc = function(value) {
            //         return formatSimple2d.format(value)+'M'}
            this.aws_commit_data.options.stackBars = true

            this.aws_commit_data.options.seriesBarWidth = 20
            this.aws_commit_data.options.seriesBarDistance = 20
            this.aws_commit_data.responsiveOptions = [
                ['screen and (max-width: 1400)', {
                    'seriesBarDistance': 5,
                    'axisX': {
                        labelInterpolationFnc(value) {
                            return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                        }
                    }
                }],
                ['screen and (max-width: 518px)', {
                    'seriesBarDistance': 10,
                    'seriesBarWidth': 10,
                    'axisX': {
                        labelInterpolationFnc(value) {
                            return value.substring(value.length - 2) + '/' + value.substring(2, 4)
                        }
                    }
                }],
            ]
        },
    },
    computed: {

    },
    data() {
        return {
            contracts_list: [],
            current_contract: null,
            aws_contracts:[],
            status_1st:'',
            status_2nd:'',
            gaps_1st:'',
            gaps_2nd:'',
            status_1st:'rgb(135, 203, 22)',
            status_2nd:'rgb(135, 203, 22)',
            gap_OLX:0,
            gap_LETGO:0,
            accessToken: '',
            options: [
                {
                    code: "CACHE",
                    name: "ElastiCache"
                },
                {
                    code: "EC2",
                    name: "EC2"
                },
                {
                    code: "ES",
                    name: "Elasticsearch"
                },
                {
                    code: "OPENSEARCH",
                    name: "Opensearch"
                },
                {
                    code: "RDS",
                    name: "RDS"
                },
                {
                    code: "RS",
                    name: "Redshift"
                },
            ],
            filtered1: [],
            filtered2: [],
            filtered3: [],
            filtered4: [],
            serviceFullNames: {
                "EC2": "EC2",
                "ES": "Elasticsearch",
                "OPENSEARCH": "Opensearch",
                "CACHE": "ElastiCache",
                "RS": "Redshift",
                "RDS": "RDS"
            },
            services: [],
            servicesAll: [],
            servicesUti: [],
            servicesUtiAll: [],
            refresh_minutes: 30,
            last_update: '',
            colors: colors,
            aws_last_spender: '',
            aws_cur_spender: '',
            aws_budget: [],
            aws_budget_data: {},
            aws_commit: [],
            aws_commit_data: {},
            aws_reservation_cov_interest_data: {},
            aws_reservation_cov_interest: {},
            aws_reservation_cov_all_data: {},
            aws_reservation_cov_all: {},
            aws_reservation_uti_interest_data: {},
            aws_reservation_uti_interest: {},
            aws_reservation_uti_all_data: {},
            aws_reservation_uti_all: {},
            loading: true,
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

</style>
